<div class="fullscreen-wrapper">

  <mat-card appearance="outlined" class="verificationCard">
    <div class="two-factor-container">
      <h2 class="titleCenter">Two-Factor Authentication</h2>

      <mat-form-field appearance="outline" class="otp-input">
        <mat-label>Authentication Code</mat-label>
        <input
          matInput
          [(ngModel)]="otp"
          maxlength="8"
          autocomplete="one-time-code"
          type="text"
          pattern="[0-9]*"
          inputmode="numeric"
          />
      </mat-form-field>

      <div class="btn-group">
        <button mat-stroked-button color="warn" (click)="cancel()">Cancel</button>
        <button class="half-width button-color"
          fxFlex="0 0 calc(50% - 4px)"
          mat-raised-button
          color="primary"
          [disabled]="isCooldown"
          (click)="sendCodeToEmail()">
          {{ isCooldown ? ('Resend in ' + countdown + 's') : ('Send Code To Email' | translate) }}
        </button>
        <button  class="half-width button-color" fxFlex="0 0 calc(50% - 4px)" mat-raised-button (click)="verify()"
        color="primary">{{ 'Verify' | translate }}</button>
      </div>

      @if (loading) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }

      @if (error) {
        <mat-error>{{ error }}</mat-error>
      }
    </div>
  </mat-card>
</div>
